(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["naghmana-wishlist"] && !Shopify.designMode) return;
  try {
    (()=>{
    const key='naghmana-saved-v1';
    const read=()=>{try{const value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value.filter(x=>x&&typeof x.handle==='string'&&typeof x.title==='string').slice(0,100):[]}catch{return []}};
    const write=items=>{try{localStorage.setItem(key,JSON.stringify(items));return true}catch{return false}};
    const safeImage=value=>{try{const url=new URL(value,window.location.origin);return url.protocol==='https:'&&(url.origin===window.location.origin||url.hostname==='cdn.shopify.com')?url.href:null}catch{return null}};
    const refresh=()=>{const items=read();document.querySelectorAll('[data-n-save]').forEach(button=>{const active=items.some(x=>x.handle===button.dataset.handle);button.setAttribute('aria-pressed',String(active));button.querySelector('[aria-hidden]').textContent=active?'♥':'♡'});const grid=document.querySelector('[data-saved-grid]');if(!grid)return;grid.replaceChildren();document.querySelector('[data-saved-empty]').hidden=items.length>0;for(const item of items){const card=document.createElement('article');card.className='n-saved-card';const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(item.handle);const imageUrl=typeof item.image==='string'?safeImage(item.image):null;if(imageUrl){const img=document.createElement('img');img.src=imageUrl;img.alt=item.title;img.loading='lazy';img.width=450;img.height=600;link.append(img)}const title=document.createElement('h2');title.textContent=item.title;link.append(title);const remove=document.createElement('button');remove.type='button';remove.textContent=grid.dataset.remove;remove.addEventListener('click',()=>{write(read().filter(x=>x.handle!==item.handle));refresh()});card.append(link,remove);grid.append(card)}};
    document.addEventListener('click',event=>{const button=event.target.closest('[data-n-save]');if(!button)return;const items=read();const exists=items.some(x=>x.handle===button.dataset.handle);const next=exists?items.filter(x=>x.handle!==button.dataset.handle):[...items,{handle:button.dataset.handle,title:button.dataset.title,image:button.dataset.image}];if(write(next))refresh();else button.querySelector('[data-save-label]').textContent=button.dataset.error||'Saving is unavailable in this browser';});
    document.addEventListener('DOMContentLoaded',refresh);document.addEventListener('shopify:section:load',refresh);window.addEventListener('storage',refresh);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["proto-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const prepared = new WeakSet();
  const attached = new WeakSet();
  const prepare = (card) => {
    if (!hover.matches || prepared.has(card)) return;
    const image = card.querySelector('.proto-card-secondary');
    if (!image) return;
    prepared.add(card);
    image.loading = 'eager';
    const ready = () => {
      if (image.naturalWidth) card.setAttribute('data-hover-ready', '');
    };
    if (typeof image.decode === 'function') {
      image.decode().then(ready).catch(() => {
        if (image.complete) ready();
        else image.addEventListener('load', ready, { once: true });
      });
    } else if (image.complete) ready();
    else image.addEventListener('load', ready, { once: true });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || !hover.matches) return;
      prepare(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  const init = () => {
    document.querySelectorAll('.proto-card').forEach((card) => {
      if (attached.has(card)) return;
      attached.add(card);
      card.addEventListener('pointerenter', () => prepare(card), { passive: true });
      if (observer) observer.observe(card);
      else prepare(card);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('naghmana:cards-updated', init);
  hover.addEventListener('change', () => {
    if (hover.matches) document.querySelectorAll('.proto-card').forEach((card) => {
      if (observer) observer.observe(card);
      else prepare(card);
    });
  });
})();
(() => {
  let dialog, opener, controller, previousOverflow, product, variant, copy, productUrl, galleryObserver;
  const root = window.Shopify?.routes?.root || '/';
  const node = (tag, className, text) => { const element = document.createElement(tag); if(className) element.className = className; if(text !== undefined) element.textContent = text; return element; };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:window.Shopify?.currency?.active || opener.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100);
  const imageUrl = (src,width) => { const url = new URL(src,location.origin); if(!['https:','http:'].includes(url.protocol)) return ''; url.searchParams.set('width',width); return url.href; };
  const imagePath = src => src ? new URL(src,location.origin).pathname : '';
  function ensureDialog() {
    if(dialog) return;
    dialog = node('dialog','proto-quick-view'); dialog.setAttribute('aria-labelledby','proto-quick-view-title'); document.body.append(dialog);
    dialog.addEventListener('click',event => { if(event.target === dialog) dialog.close(); });
    dialog.addEventListener('close',() => { controller?.abort(); galleryObserver?.disconnect(); document.body.style.overflow = previousOverflow; opener?.focus({preventScroll:true}); });
  }
  function shell() {
    galleryObserver?.disconnect(); dialog.replaceChildren();
    const close = node('button','proto-quick-view__close','\u00d7'); close.type = 'button'; close.setAttribute('aria-label',copy.close); close.addEventListener('click',() => dialog.close()); dialog.append(close); return close;
  }
  function render() {
    shell();
    const layout = node('div','proto-quick-view__layout');
    const gallery = node('div','proto-quick-view__gallery');
    const viewport = node('div','proto-quick-view__viewport'); viewport.tabIndex = 0; viewport.setAttribute('role','region'); viewport.setAttribute('aria-label',copy.gallery);
    const thumbnails = node('div','proto-quick-view__thumbnails'); thumbnails.setAttribute('aria-label',copy.images);
    gallery.append(viewport,thumbnails);
    const info = node('div','proto-quick-view__info');
    const title = node('h2','proto-quick-view__title',product.title); title.id = 'proto-quick-view-title';
    const stock = node('span','proto-quick-view__stock');
    const sku = node('p','proto-quick-view__sku');
    const price = node('p','proto-quick-view__price');
    const form = node('form','proto-quick-view__form'); form.method = 'post'; form.action = root+'cart/add';
    const variantInput = node('input'); variantInput.type = 'hidden'; variantInput.name = 'id';
    const options = node('div','proto-quick-view__options');
    const choices = []; const colorIndex = product.options.findIndex(option => /colou?r/i.test(option.name));
    product.options.forEach((option,index) => {
      if(option.name === 'Title' && option.values[0] === 'Default Title') return;
      const field = node('fieldset','proto-quick-view__option'); const legend = node('legend','',option.name);
      const values = node('div','proto-quick-view__choices'); field.append(legend,values);
      option.values.forEach((value,valueIndex) => {
        const label = node('label','proto-quick-view__choice');
        const input = node('input'); input.type = 'radio'; input.name = 'options['+option.name+']'; input.value = value; input.checked = variant.options[index] === value;
        input.id = 'qv-option-'+index+'-'+valueIndex;
        const text = node('span','',value); label.append(input,text); values.append(label); choices.push({input,index,label});
        input.addEventListener('change',() => {
          const wanted = [...variant.options]; wanted[index] = value;
          variant = product.variants.find(entry => entry.options.every((v,i) => v === wanted[i])) || product.variants.filter(entry => entry.options[index] === value).sort((a,b) => Number(b.available)-Number(a.available) || b.options.filter((v,i)=>v===wanted[i]).length-a.options.filter((v,i)=>v===wanted[i]).length)[0];
          update();
        });
      }); options.append(field);
    });
    const quantityField = node('div','proto-quick-view__quantity'); const quantityLabel = node('label','',copy.quantity); quantityLabel.htmlFor = 'qv-quantity';
    const quantityControls = node('div','proto-quick-view__quantity-controls');
    const quantity = node('input'); quantity.type = 'number'; quantity.name = 'quantity'; quantity.id = 'qv-quantity'; quantity.value = '1'; quantity.min = '1'; quantity.step = '1';
    const minus = node('button','','\u2212'); minus.type = 'button'; minus.setAttribute('aria-label',copy.decrease);
    const plus = node('button','','+'); plus.type = 'button'; plus.setAttribute('aria-label',copy.increase);
    quantityControls.append(minus,quantity,plus); quantityField.append(quantityLabel,quantityControls);
    const quantityState = () => { minus.disabled = Number(quantity.value) <= Number(quantity.min); plus.disabled = Boolean(quantity.max) && Number(quantity.value) >= Number(quantity.max); };
    minus.addEventListener('click',() => { quantity.stepDown(); quantityState(); }); plus.addEventListener('click',() => { quantity.stepUp(); quantityState(); }); quantity.addEventListener('input',quantityState);
    const add = node('button','n-btn n-btn--primary btn-teal proto-quick-view__add'); add.type = 'submit';
    const status = node('p','proto-quick-view__status'); status.setAttribute('role','status');
    const detailsLink = node('a','proto-quick-view__details',copy.details+' \u2192'); detailsLink.href = productUrl.href;
    const bridal = opener.dataset.enquiry === 'true';
    form.append(variantInput,options,quantityField,add,status); info.append(stock,title,sku,price,form,detailsLink);
    const details = node('details','proto-quick-view__description'); details.append(node('summary','',copy.description));
    const description = node('div'); const parsed = new DOMParser().parseFromString(product.description || '','text/html');
    parsed.querySelectorAll('script,style,iframe,object').forEach(element => element.remove());
    parsed.querySelectorAll('p,li,br,h1,h2,h3,h4').forEach(element => element.append(document.createTextNode('\n')));
    description.textContent = parsed.body.textContent.trim(); details.append(description); if(description.textContent) info.append(details);
    layout.append(gallery,info); dialog.append(layout);
    let galleryColor;
    function images() {
      galleryObserver?.disconnect(); viewport.replaceChildren(); thumbnails.replaceChildren(); viewport.scrollTop = 0;
      const color = colorIndex >= 0 ? variant.options[colorIndex].toLowerCase() : '';
      const colors = colorIndex >= 0 ? product.options[colorIndex].values.map(value => value.toLowerCase()) : [];
      const media = (product.media || []).filter(item => item.media_type === 'image');
      const catalogImages = JSON.parse(opener.dataset.quickViewImages || '[]');
      let pictures = product.images.map(src => ({src,alt:catalogImages.find(item => imagePath(item.src)===imagePath(src))?.alt || media.find(item=>imagePath(item.src || item.preview_image?.src)===imagePath(src))?.alt || product.title}));
      const filtered = pictures.filter(picture => { const labels = picture.alt.split(/[\u00b7\u2014]/).map(text=>text.trim().toLowerCase()); const label = colors.find(value=>labels.includes(value)); return !label || label===color; });
      if(filtered.length) pictures = filtered;
      const preferred = pictures.findIndex(picture=>imagePath(picture.src)===imagePath(variant.featured_image?.src));
      if(preferred>0) pictures.unshift(pictures.splice(preferred,1)[0]);
      pictures.forEach((picture,index) => {
        const figure = node('figure','proto-quick-view__figure'); figure.dataset.imageIndex = index;
        const image = node('img','proto-quick-view__image'); image.src = imageUrl(picture.src,900); image.srcset = [360,540,720,900,1200].map(width=>imageUrl(picture.src,width)+' '+width+'w').join(',');
        image.alt = picture.alt; image.width = 720; image.height = 1080; image.sizes = '(max-width: 900px) calc(100vw - 72px), 560px'; image.loading = index ? 'lazy' : 'eager'; figure.append(image); viewport.append(figure);
        const button = node('button','proto-quick-view__thumbnail'); button.type = 'button'; button.setAttribute('aria-label',copy.image+' '+(index+1)); button.setAttribute('aria-current',String(index===0));
        const thumbnail = node('img'); thumbnail.src = imageUrl(picture.src,180); thumbnail.alt = ''; thumbnail.width = 90; thumbnail.height = 135; thumbnail.loading = 'lazy'; button.append(thumbnail);
        button.addEventListener('click',() => viewport.scrollTo({top:figure.offsetTop,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})); thumbnails.append(button);
      });
      if('IntersectionObserver' in window) {
        galleryObserver = new IntersectionObserver(entries=>{ for(const entry of entries) if(entry.isIntersecting && entry.intersectionRatio>=.55) { const index = Number(entry.target.dataset.imageIndex); [...thumbnails.children].forEach((button,i)=>button.setAttribute('aria-current',String(i===index))); } },{root:viewport,threshold:.55});
        [...viewport.children].forEach(figure=>galleryObserver.observe(figure));
      }
      galleryColor = color;
    }
    function update() {
      variantInput.value = variant?.id || ''; const available = Boolean(variant?.available);
      stock.textContent = bridal ? copy.made_to_order : available ? copy.in_stock : copy.unavailable; stock.dataset.available = available;
      sku.textContent = variant?.sku || ''; sku.hidden = !variant?.sku;
      price.textContent = bridal ? copy.enquiry : money(variant?.price ?? product.price);
      add.disabled = !available; add.textContent = available ? copy.add : copy.sold_out; add.hidden = bridal; quantityField.hidden = bridal;
      const rule = variant?.quantity_rule || {min:1,increment:1}; quantity.min = String(rule.min || 1); quantity.step = String(rule.increment || 1);
      if(rule.max) quantity.max = String(rule.max); else quantity.removeAttribute('max');
      if(Number(quantity.value)<Number(quantity.min)) quantity.value = quantity.min;
      if(quantity.max && Number(quantity.value)>Number(quantity.max)) quantity.value = quantity.max; quantityState();
      choices.forEach(({input,index,label})=> {
        input.checked = variant?.options[index]===input.value;
        const exists = product.variants.some(entry=>entry.options[index]===input.value && (index===colorIndex || entry.options.every((v,i)=>i===index || v===variant.options[i])));
        input.disabled = !exists; label.dataset.disabled = !exists;
      });
      if(variant) { const url = new URL(productUrl); url.searchParams.set('variant',variant.id); detailsLink.href = url.href; }
      status.textContent = ''; const color = colorIndex>=0 ? variant.options[colorIndex].toLowerCase() : '';
      if(galleryColor !== color) images();
    }
    form.addEventListener('submit',async event => {
      event.preventDefault(); if(!variant?.available || bridal || !form.reportValidity()) return;
      add.disabled = true; status.textContent = copy.adding;
      try {
        const response = await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}}); const result = await response.json();
        if(!response.ok) throw new Error(result.description || copy.error);
        status.textContent = copy.added+' '; const bag = node('a','',copy.bag+' \u2192'); bag.href = root+'cart'; status.append(bag);
        const cartResponse = await fetch(root+'cart.js'); if(cartResponse.ok) { const cart = await cartResponse.json(); document.querySelector('[data-cart-link]')?.setAttribute('aria-label','Cart, '+cart.item_count+' items'); const count = document.querySelector('[data-cart-count]'); if(count) {count.textContent=cart.item_count; count.style.display=cart.item_count?'block':'none';} }
      } catch(error) {status.textContent=error.message || copy.error;} finally {add.disabled=!variant?.available;}
    }); update();
  }
  document.addEventListener('click',async event => {
    const trigger = event.target.closest('[data-quick-view]'); if(!trigger) return; event.preventDefault();
    opener = trigger; copy = JSON.parse(trigger.dataset.quickViewCopy); const link = trigger.closest('.proto-card')?.querySelector('[data-card-link]'); productUrl = new URL(link?.href || trigger.dataset.productUrl,location.origin);
    ensureDialog(); controller?.abort(); controller = new AbortController(); const request=controller;
    const close=shell(); const loading=node('h2','proto-quick-view__loading',copy.loading); loading.id='proto-quick-view-title'; loading.setAttribute('role','status'); dialog.append(loading);
    if(!dialog.open) { previousOverflow=document.body.style.overflow; document.body.style.overflow='hidden'; dialog.showModal(); } close.focus();
    try {
      const endpoint=new URL(productUrl); endpoint.pathname+='.js'; endpoint.search=''; const response=await fetch(endpoint,{signal:request.signal,headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error(copy.error); const result=await response.json(); if(request.signal.aborted || !dialog.open) return;
      product=result; variant=product.variants.find(entry=>String(entry.id)===productUrl.searchParams.get('variant')) || product.variants.find(entry=>entry.available) || product.variants[0]; render(); dialog.querySelector('.proto-quick-view__close').focus();
    } catch(error) {
      if(error.name==='AbortError') return; shell(); const message=node('h2','proto-quick-view__loading',copy.error); message.id='proto-quick-view-title'; const link=node('a','proto-quick-view__details',copy.details+' \u2192'); link.href=productUrl.href; dialog.append(message,link);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["proto-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const menu = document.querySelector('[data-profile-menu]');
  if (!menu || menu.dataset.initialized) return;
  menu.dataset.initialized = 'true';
  const trigger = menu.querySelector('summary');
  menu.addEventListener('mouseenter', () => {
    if (matchMedia('(hover: hover)').matches) menu.open = true;
  });
  menu.addEventListener('mouseleave', () => {
    if (!menu.contains(document.activeElement)) menu.open = false;
  });
  trigger.addEventListener('click', (event) => {
    if (event.detail > 0 && matchMedia('(hover: hover)').matches) {
      event.preventDefault();
      menu.open = true;
    }
  });
  menu.addEventListener('focusout', (event) => {
    if (!menu.contains(event.relatedTarget)) menu.open = false;
  });
  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target) && !menu.matches(':hover')) menu.open = false;
  });
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      trigger.focus();
      event.preventDefault();
    }
  });
})();
(() => {
  const toggle = document.querySelector('[data-header-search-toggle]');
  const panel = document.querySelector('[data-header-search]');
  if (!toggle || !panel) return;
  const form = panel.querySelector('form');
  const input = panel.querySelector('input');
  const results = panel.querySelector('[data-search-results]');
  const status = panel.querySelector('[data-search-status]');
  const copy = JSON.parse(panel.dataset.copy);
  const root = window.Shopify?.routes?.root || '/';
  let timer, controller, sequence = 0;
  const close = () => {
    panel.hidden = true; toggle.setAttribute('aria-expanded', 'false');
    controller?.abort(); sequence++; clearTimeout(timer);
  };
  const open = () => {
    document.querySelector('[data-profile-menu]')?.removeAttribute('open');
    const mobile = document.querySelector('[data-mobile-menu]');
    if (mobile) { mobile.style.display = 'none'; mobile.dataset.open = 'false'; }
    document.querySelector('[data-action="toggleMobile"]')?.setAttribute('aria-expanded','false');
    panel.hidden = false; toggle.setAttribute('aria-expanded','true'); input.focus();
    if (input.value.trim()) search();
  };
  toggle.addEventListener('click', () => panel.hidden ? open() : close());
  panel.querySelector('[data-search-close]').addEventListener('click', () => { close(); toggle.focus(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); toggle.focus(); }
  });
  document.addEventListener('click', event => {
    if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) close();
  });
  async function search() {
    const query = input.value.trim();
    clearTimeout(timer); controller?.abort();
    const requestId = ++sequence;
    results.replaceChildren();
    if (!query) { status.textContent = ""; results.removeAttribute('aria-busy'); return; }
    status.textContent = copy.loading; results.setAttribute('aria-busy','true');
    controller = new AbortController();
    const url = new URL(root + 'search/suggest.json', location.origin);
    url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    try {
      const response = await fetch(url, {signal: controller.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error();
      const data = await response.json();
      if (requestId !== sequence || panel.hidden) return;
      const products = data.resources?.results?.products || [];
      for (const product of products) {
        const link = document.createElement('a'); link.className = 'n-header-search__result';
        link.href = product.url;
        const source = [product.featured_image?.url,product.featured_image?.src,product.image,product.featured_image].find(value => typeof value === 'string' && value);
        if (typeof source === 'string' && source) {
          const image = document.createElement('img'); const imageUrl = new URL(source,location.origin);
          imageUrl.searchParams.set('width','160'); image.src = imageUrl.href;
          image.alt = ''; image.width = 64; image.height = 80; image.loading = 'lazy'; link.append(image);
        }
        const title = document.createElement('span'); title.textContent = product.title;
        link.append(title); results.append(link);
      }
      status.textContent = products.length ? copy.results.replace('[count]',products.length) : copy.empty;
    } catch (error) {
      if (error.name !== 'AbortError' && requestId === sequence) status.textContent = copy.error;
    } finally { if (requestId === sequence) results.removeAttribute('aria-busy'); }
  }
  input.addEventListener('input', () => { controller?.abort(); sequence++; clearTimeout(timer); timer = setTimeout(search,200); });
  form.addEventListener('submit', event => { event.preventDefault(); search(); });
})();
  } catch(e) { console.error(e); }
})();

})();
